import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro';

import { mapGridIndexes } from '@shared/commonFunctions';
import { gridCurrencyCell, gridPercentageCell, dataGridCol } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';

import { ValuationGrid } from '@styles/ContactManager/DealStyles';
import { IValuation } from '../interfaces';

interface IValuationsProps {
  data: IValuation[];
  lederDefaultValuation?: string[];
}

export const Valuations = ({ data = [], lederDefaultValuation = [] }: IValuationsProps) => {
  const columns: GridColDef<IValuation>[] = [
    dataGridCol('percentage', {
      headerName: 'LTV',
      ...gridPercentageCell,
    }),
    dataGridCol('kbbRetail', {
      headerName: 'KBB',
      ...gridCurrencyCell,
    }),
    dataGridCol('kbbWholeSale', {
      headerName: 'KBB (W)',
      ...gridCurrencyCell,
    }),
    dataGridCol('nadaRetail', {
      headerName: 'JD Power',
      ...gridCurrencyCell,
    }),
    dataGridCol('nadaTradeIn', {
      headerName: 'JD Power (T)',
      ...gridCurrencyCell,
    }),
    dataGridCol('kbbFinanceExpress', {
      headerName: 'KBB (FEX)',
      ...gridCurrencyCell,
    }),
  ].map((column) => ({ ...column, flex: 1 }));

  return (
    <ValuationGrid>
      <PhoenixGrid
        noButton
        withHeader
        autoHeight
        hideFooter
        disableSelectionOnClick
        name="Valuation"
        columns={columns}
        loading={!data}
        rows={mapGridIndexes(data)}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getCellClassName={(params: GridCellParams<any, any, number>) => {
          const fieldName = String(params.field ?? '');
          const matches = lederDefaultValuation.some((v) => String(v ?? '').toLowerCase() === fieldName.toLowerCase());

          if (matches) {
            return 'heighlightDefaultValuation';
          }

          return '';
        }}
      />
    </ValuationGrid>
  );
};
